import { connect, useSelector } from "react-redux";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
	CAlert,
	CButton, CCol,
	CForm, CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText, CModal, CModalBody, CModalHeader, CModalTitle,
	CRow
} from "@coreui/react";
import { AgGridReact } from "ag-grid-react";
import { Loading } from "../../../components/common";

import * as api from "../../../api/api";
import BrandListWhere from "../where/BrandListWhere";
import HandleProductStoreCorner from "../product/HandleProductStoreCorner";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const BrandList = (props) => {
	const defaultBrand = {
		brandCd: "", brandNm: "", ownerNm: "", busiNo: "", telNo: "", faxNo: "", addr1: "", addr2: ""
	}

	const { user } = useSelector((props) => props.account);
	const [searchForm, setSearchForm] = useState({
		brandCd: "",
		brandNm: ""
	});
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState({});
	const [rowData, setRowData] = useState([]);
	const [restBrandCd, setRestBrandCd] = useState("");
	const [selectedBrand, setSelectedBrand] = useState(defaultBrand);

	const [columnDefs] = useState([
		{ field: "brandCd", headerName: "코드", width: 120 },
		{ field: "brandNm", headerName: "휴게소명" },
		{ field: "storeCnt", headerName: "매장수", maxWidth: 80 },
	]);

	useEffect(() => {
		console.log("### BrandList ###");
	}, [searchForm])

	const search = async () => {
		setError({visible: false, message: ""});
		console.log(">>> props :: ", props.selected);

		const {cmpCd} = props.selected;
		const params = {
			cmpCd: cmpCd,
			brandCd: searchForm.brandCd,
			brandNm: searchForm.brandNm,
		};
		setLoading(true);
		try {
			const { data: result } = await api.getBrandListStoreCnt(params);
			const { responseBody, responseCode, responseMessage } = result;
			if (responseCode === "200") {
				// 성공
				setRowData(responseBody);
			} else {

			}
		} catch (e) {
			console.error(e.message);
		} finally {
			setLoading(false);
		}
	};

	const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
	const gridStyle = useMemo(() => ({ height: 450, width: "100%" }), []);

	const onRowSelected = useCallback((event) => {
		console.log(">>> event :: ", event);

		setSelectedBrand(defaultBrand);
		setSelectedBrand(event.node.data);
		setRestBrandCd(event.node.data.brandCd);

	}, []);

	const handleSelect = (code, value) => {
		if (value === "C") {
			setSearchForm((state) => ({
				...state,
				cmpCd: code, brandCd: "", storeCd: "", cornerCd: ""
			}));
		} else if (value === "B") {
			setSearchForm((state) => ({
				...state,
				brandCd: code, storeCd: "", cornerCd: ""
			}));
		} else if (value === "S") {
			setSearchForm((state) => ({
				...state,
				storeCd: code, cornerCd: ""
			}));
		} else if (value === "O") {
			setSearchForm((state) => ({
				...state,
				cornerCd: code
			}));
		}
	}

	const init = () => {
		setError({visible: false, message: ""});

		setRestBrandCd("");
		setSelectedBrand(defaultBrand);
	}

	const save = () => {
		setError({visible: false, message: ""});
		if (restBrandCd.length  === 0) {
			setError({
				visible: true, message: "휴게소코드를 입력해주세요."
			})
			return;
		}

		if (confirm("저장하시겠습니까?")) {
			const {cmpCd, brandCd} = props.selected;

			const params = {
				...selectedBrand,
				cmpCd: cmpCd,
				brandCd: restBrandCd,
				instUser: selectedBrand.instUser ? selectedBrand.instUser : user.userId,
				updUser: user.userId,
			}
			console.log(">>> params :: ", params);

			setLoading(true);
			api.putBrand(params).then((result) => {
				const {responseBody, responseCode, responseMessage} = result.data;
				if (responseCode === "200") {
					// 성공
					alert("정상적으로 처리되었습니다.");
					search();
				}
			})
				.finally(() => {
					setLoading(false)
				})
		}
	}

	return (
		<div style={containerStyle}>
			{loading ? <Loading/> : null}
			{error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
			<div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
				<h5>휴게소 정보관리</h5>
				<div className="d-grid gap-1 d-md-flex justify-content-md-end">
					<CButton color="dark" onClick={search}>조회</CButton>
				</div>
			</div>
			<CForm>
				<StoreCornerListWhere type={"B"} account={props.account} selected={searchForm} onSelect={(c, v) => handleSelect(c, v)}/>
			</CForm>
			<div style={{ height: 10 }}/>
			<CRow>
				<CCol xs={5}>
					<div className="ag-theme-alpine" style={gridStyle}>
						{loading ? <Loading/> : null}
						<AgGridReact
							rowSelection={"single"}
							onRowClicked={onRowSelected}
							rowData={rowData}
							pagination={true}
							suppressDragLeaveHidesColumns={true}
							columnDefs={columnDefs}>
						</AgGridReact>
					</div>
				</CCol>
				<CCol xs={7}>
					<div className="d-grid gap-1 d-md-flex justify-content-between" style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
						<h5>[{selectedBrand.brandCd}] {selectedBrand.brandNm}</h5>
						<div className="d-grid gap-1 d-md-flex justify-content-md-end">
							<CButton size={"sm"} color="dark" onClick={init}>신규</CButton>
							<CButton size={"sm"} color="dark" onClick={save}>저장</CButton>
						</div>
					</div>
					<CRow>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>휴게소코드</CInputGroupText>
								<CFormInput id="brandCd" value={restBrandCd ? restBrandCd : ""}
											onChange={(e) => {
												setRestBrandCd(e.target.value)
											}}
											disabled={selectedBrand.brandCd !== ""}/>
							</CInputGroup>
						</CCol>
					</CRow>
					<CRow>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>휴게소명</CInputGroupText>
								<CFormInput id="brandNm" value={selectedBrand.brandNm ? selectedBrand.brandNm : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													brandNm: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>대표자명</CInputGroupText>
								<CFormInput id="ownerNm" value={selectedBrand.ownerNm ? selectedBrand.ownerNm : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													ownerNm: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
					</CRow>
					<CRow>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>사업자번호</CInputGroupText>
								<CFormInput id="busiNo" value={selectedBrand.busiNo ? selectedBrand.busiNo : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													busiNo: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
					</CRow>
					<CRow>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>전화번호</CInputGroupText>
								<CFormInput id="telNo" value={selectedBrand.telNo ? selectedBrand.telNo : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													telNo: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
						<CCol xs={6}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}>FAX</CInputGroupText>
								<CFormInput id="faxNo" value={selectedBrand.faxNo ? selectedBrand.faxNo : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													faxNo: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
					</CRow>
					<CRow>
						<CCol xs={12}>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}><span style={{color: "red"}}>*</span>주소</CInputGroupText>
								<CFormInput id="addr1" value={selectedBrand.addr1 ? selectedBrand.addr1 : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													addr1: e.target.value
												}))
											}}/>
							</CInputGroup>
							<CInputGroup className={"mb-1"} size={"sm"}>
								<CInputGroupText style={{ width: 100 }}>상세주소</CInputGroupText>
								<CFormInput id="addr2" value={selectedBrand.addr2 ? selectedBrand.addr2 : ""}
											onChange={(e) => {
												setSelectedBrand((state) => ({
													...state,
													addr2: e.target.value
												}))
											}}/>
							</CInputGroup>
						</CCol>
					</CRow>
				</CCol>
			</CRow>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { account, store, selected } = state;
	return {
		account, store, selected
	};
};

export default connect(mapStateToProps, null)(BrandList);
